/**
 * Standard set of HTML attributes for password and secret-like fields.
 *
 * Fixes the iPad/Safari behaviour where the first character of a
 * password field is auto-capitalised and autocorrect kicks in.
 * Applies to:
 *   • login / register password
 *   • change password (current + new + confirm)
 *   • forgot / reset password
 *   • new-user temporary password (admin console)
 *   • administrator password reset flows
 *   • any future MFA recovery-code / passphrase field
 *
 * These attributes are safe to spread on the `<input>` alongside the
 * component's own `type`, `autoComplete`, `data-testid`, etc.
 */
export const PASSWORD_INPUT_PROPS = {
    autoCapitalize: "none",
    autoCorrect: "off",
    spellCheck: false,
};
